import { apiGet } from './client';

export const searchIcd11 = (q, limit = 25) =>
    apiGet('api/emr-master/icd11', { q, limit });

export const searchIcd10 = (q, limit = 25) =>
    apiGet('api/emr-master/icd10', { q, limit });

export const searchMedication = (q, limit = 25) =>
    apiGet('api/emr-master/medications', { q, limit });

export const listLabTests = () =>
    apiGet('api/emr-master/lab-tests');

export const listRadiologyTests = () =>
    apiGet('api/emr-master/radiology-tests');

export const listPhysicalExamSystems = () =>
    apiGet('api/emr-master/physical-exam-systems');
